export default {
  WEIGHT: "weight",
  TIME: "time",
  DISTANCE: "distance",
  ROUNDS: "rounds",
  REPS: "reps",
  DESCRIPTION: "description",
};
